var map = {
	"./2023.md": [
		9020,
		20
	],
	"./about-writing.md": [
		721,
		721
	],
	"./ai-takes-your-job.md": [
		6470,
		470
	],
	"./circles.md": [
		6964,
		964
	],
	"./computer-science.md": [
		4813,
		813
	],
	"./debugging.md": [
		1083,
		83
	],
	"./discipline-and-curiosity.md": [
		7493,
		493
	],
	"./good-code.md": [
		7554,
		554
	],
	"./gunshots.md": [
		6173,
		173
	],
	"./home.md": [
		8113,
		113
	],
	"./i-hate-tech.md": [
		2658,
		658
	],
	"./layoff.md": [
		2196,
		196
	],
	"./max.md": [
		3269,
		269
	],
	"./perfectionist.md": [
		8554,
		680
	],
	"./rules-principles.md": [
		6993,
		993
	],
	"./survivor.md": [
		2153,
		153
	],
	"./time.md": [
		8363,
		363
	],
	"./trauma-intro.md": [
		3008,
		8
	],
	"./trauma-lesson.md": [
		5729,
		729
	],
	"./trauma-ssri.md": [
		2483,
		483
	],
	"./trauma-wish.md": [
		9564,
		564
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3336;
module.exports = webpackAsyncContext;